import Jt808SetBatchParameterdataModal from './jt808-set-batch-parameterdata-modal.vue'
export default Jt808SetBatchParameterdataModal
